// removed by extract-text-webpack-plugin
module.exports = {"optional-extras":"src-components-ProductSummary-OptionalExtras----OptionalExtras-module---optional-extras---1noGM","wrapper":"src-components-ProductSummary-OptionalExtras----OptionalExtras-module---wrapper---1KiGO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductSummary/OptionalExtras/OptionalExtras.module.scss
// module id = 1200
// module chunks = 137591856104208